<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
    <div class="content-top">
      <div class="content-title">权限组设置</div>
      <FormItem label="权限组" prop="name" :error="nameError">
        <Input v-model.trim="formValidate.name" placeholder="请输入权限组名称"></Input>
      </FormItem>
        <p class="content-hint" style="margin-bottom: 4px">为权限组设置特定名称，便于添加管理员时选择使用</p>
      <FormItem label="账号权限">
        <Checkbox :value="allIsTrue" @click.prevent.native="CheckAll(true)">全部操作</Checkbox>
      </FormItem>
      <p class="content-hint">勾选后选中全部操作功能，可根据需要从设置详情中进行分组设置</p>
    </div>
    <div class="content-bottom" v-loading="loading">
      <p class="content-title">权限详情</p>
      <ul>
        <li>
          <span class="checkbox-all">
            <Checkbox :value="userIsTrue" @click.prevent.native="manageChenAll('user'),CheckAll(false)">用户管理<span>|</span></Checkbox>
          </span>
          <span>
            <CheckboxGroup v-model="formValidate.user" @on-change="checkAllChange(formValidate.user, 'user'),CheckAll(false)">
              <span class="checkbox-val" v-for="(itemUser, index) in userData" :key="index" >
                 <Checkbox :label="itemUser.id"><span>{{itemUser.name}}</span></Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </li>
        <li>
         <span class="checkbox-all">
            <Checkbox v-model="dealIsTrue" @click.prevent.native="manageChenAll('deal'),CheckAll(false)">交易管理<span>|</span></Checkbox>
          </span>
          <span>
            <CheckboxGroup v-model="formValidate.deal" @on-change="checkAllChange(formValidate.deal, 'deal'),CheckAll(false)">
              <span class="checkbox-val" v-for="(itemDeal, index) in dealData" :key="index" >
                <Checkbox :label="itemDeal.id"><span>{{itemDeal.name}}</span></Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </li>
        <li>
         <span class="checkbox-all">
            <Checkbox v-model="contentIsTrue" @click.prevent.native="manageChenAll('content'),CheckAll(false)">内容管理<span>|</span></Checkbox>
          </span>
          <span>
            <CheckboxGroup v-model="formValidate.content" @on-change="checkAllChange(formValidate.content, 'content'),CheckAll(false)">
              <span class="checkbox-val" v-for="(itemContent, index) in contentData" :key="index" >
                 <Checkbox :label="itemContent.id"><span>{{itemContent.name}}</span></Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </li>
        <li>
          <span class="checkbox-all">
            <Checkbox v-model="calculateIsTrue" @click.prevent.native="manageChenAll('calculate'),CheckAll(false)">结算管理<span>|</span></Checkbox>
          </span>
          <span>
            <CheckboxGroup v-model="formValidate.calculate" @on-change="checkAllChange(formValidate.calculate, 'calculate'),CheckAll(false)">
              <span class="checkbox-val" v-for="(itemCalculate, index) in calculateData" :key="index" >
                <Checkbox :label="itemCalculate.id"><span>{{itemCalculate.name}}</span></Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </li>
        <li>
          <span class="checkbox-all">
            <Checkbox v-model="invoiceIsTrue" @click.prevent.native="manageChenAll('invoice'),CheckAll(false)">发票信息<span>|</span></Checkbox>
          </span>
          <span>
            <CheckboxGroup v-model="formValidate.invoice" @on-change="checkAllChange(formValidate.invoice, 'invoice'),CheckAll(false)">
              <span class="checkbox-val" v-for="(itemInvoice, index) in invoiceData" :key="index">
                 <Checkbox :label="itemInvoice.id"><span>{{itemInvoice.name}}</span></Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </li>
      </ul>
    </div>
    <div class="content-footer">
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')">提交保存</Button>
      </FormItem>
    </div>
  </Form>
</template>
<script>
import { getJurisdictionDetails, getJurisdictionCheck } from '@/api/app'
export default {
  props: ['nameError'],
  data() {
    return {
      formValidate: {
        name: '',
        gid: '',
        user: [],
        deal: [],
        content: [],
        calculate: [],
        invoice: []
      },
      loading: false, // loading
      userData: [],
      dealData: [],
      contentData: [],
      calculateData: [],
      invoiceData: [],
      allIsTrue: false, // 全部操作
      userIsTrue: false, // 用户管理
      dealIsTrue: false, // 交易管理
      contentIsTrue: false, // 内容管理
      calculateIsTrue: false, // 结算管理
      invoiceIsTrue: false, // 发票管理
      ruleValidate: {
        name: [
          { required: true, message: '权限组不能为空', trigger: 'blur' }
        ]
      },
      limitData: '' // 我想要的数据结构 封
    }
  },
  computed: {},
  methods: {
    // 提交
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('jurisdictionWay', this.formValidate)
        }
      })
    },
    // 全部操作
    CheckAll(type) {
      if (type) {
        if (!this.allIsTrue) {
          this.allIsTrue = true
          this.userIsTrue = true
          this.formValidate.user = this.mapData(this.userData)
          this.dealIsTrue = true
          this.formValidate.deal = this.mapData(this.dealData)
          this.contentIsTrue = true
          this.formValidate.content = this.mapData(this.contentData)
          this.calculateIsTrue = true
          this.formValidate.calculate = this.mapData(this.calculateData)
          this.invoiceIsTrue = true
          this.formValidate.invoice = this.mapData(this.invoiceData)
        } else {
          this.allIsTrue = false
          this.userIsTrue = false
          this.formValidate.user = []
          this.dealIsTrue = false
          this.formValidate.deal = []
          this.contentIsTrue = false
          this.formValidate.content = []
          this.calculateIsTrue = false
          this.formValidate.calculate = []
          this.invoiceIsTrue = false
          this.formValidate.invoice = []
        }
      } else {
        if (!this.allIsTrue && this.userIsTrue && this.dealIsTrue && this.contentIsTrue && this.calculateIsTrue && this.invoiceIsTrue) {
          this.allIsTrue = true
        } else {
          this.allIsTrue = false
        }
      }
    },
    // 管理的全选
    manageChenAll(name) {
      if (name === 'user') {
        if (!this.userIsTrue) {
          this.userIsTrue = true
          this.formValidate.user = this.mapData(this.userData)
        } else {
          this.userIsTrue = false
          this.formValidate.user = []
        }
      } else if (name === 'deal') {
        if (!this.dealIsTrue) {
          this.dealIsTrue = true
          this.formValidate.deal = this.mapData(this.dealData)
        } else {
          this.dealIsTrue = false
          this.formValidate.deal = []
        }
      } else if (name === 'content') {
        if (!this.contentIsTrue) {
          this.contentIsTrue = true
          this.formValidate.content = this.mapData(this.contentData)
        } else {
          this.contentIsTrue = false
          this.formValidate.content = []
        }
      } else if (name === 'calculate') {
        if (!this.calculateIsTrue) {
          this.calculateIsTrue = true
          this.formValidate.calculate = this.mapData(this.calculateData)
        } else {
          this.calculateIsTrue = false
          this.formValidate.calculate = []
        }
      } else if (name === 'invoice') {
        if (!this.invoiceIsTrue) {
          this.invoiceIsTrue = true
          this.formValidate.invoice = this.mapData(this.invoiceData)
        } else {
          this.invoiceIsTrue = false
          this.formValidate.invoice = []
        }
      }
    },
    // 选中每个选项后的操作
    checkAllChange(data, name) {
      if (name === 'user') {
        if (data.length === this.userData.length) {
          this.userIsTrue = true
        } else {
          this.userIsTrue = false
        }
      } else if (name === 'deal') {
        if (data.length === this.dealData.length) {
          this.dealIsTrue = true
        } else {
          this.dealIsTrue = false
        }
      } else if (name === 'content') {
        if (data.length === this.contentData.length) {
          this.contentIsTrue = true
        } else {
          this.contentIsTrue = false
        }
      } else if (name === 'calculate') {
        if (data.length === this.calculateData.length) {
          this.calculateIsTrue = true
        } else {
          this.calculateIsTrue = false
        }
      } else if (name === 'invoice') {
        if (data.length === this.invoiceData.length) {
          this.invoiceIsTrue = true
        } else {
          this.invoiceIsTrue = false
        }
      }
    },
    // 获取权限详情列表
    jurisdictionDetails() {
      this.loading = true
      getJurisdictionDetails().then(res => {
        if (res.code === 0) {
          this.loading = false
          this.limitData = res.result.map(item => { // 封 07-01 给返回的权限加isSel 和 allSel字段
            item.isSel = false
            item.allSel = []
            return item
          })
          this.userData = res.result[0].children
          this.dealData = res.result[1].children
          this.contentData = res.result[2].children
          this.calculateData = res.result[3].children
          this.invoiceData = res.result[4].children
          if (this.$route.query.id !== undefined) {
            this.formValidate.name = this.$route.query.name
            this.formValidate.gid = this.$route.query.id
            this.jurisdictionCheck(this.$route.query.id)
          }
        }
      })
    },
    // 编辑时获取勾选的权限列表
    jurisdictionCheck(id) {
      getJurisdictionCheck({
        gid: id
      }).then(res => {
        if (res.code === 0) {
          if (res.result.data[0].limits !== '') {
            var newLimits = JSON.parse(res.result.data[0].limits)
            if (newLimits['1000'] !== undefined) {
              this.formValidate.user = this.mapCheckData(newLimits['1000'])
              if (newLimits['1000'].length === this.userData.length) {
                this.userIsTrue = true
              } else {
                this.userIsTrue = false
              }
            }
            if (newLimits['2000'] !== undefined) {
              this.formValidate.deal = this.mapCheckData(newLimits['2000'])
              if (newLimits['2000'].length === this.dealData.length) {
                this.dealIsTrue = true
              } else {
                this.dealIsTrue = false
              }
            }
            if (newLimits['3000'] !== undefined) {
              this.formValidate.content = this.mapCheckData(newLimits['3000'])
              if (newLimits['3000'].length === this.contentData.length) {
                this.contentIsTrue = true
              } else {
                this.contentIsTrue = false
              }
            }
            if (newLimits['4000'] !== undefined) {
              this.formValidate.calculate = this.mapCheckData(newLimits['4000'])
              if (newLimits['4000'].length === this.calculateData.length) {
                this.calculateIsTrue = true
              } else {
                this.calculateIsTrue = false
              }
            }
            if (newLimits['5000'] !== undefined) {
              this.formValidate.invoice = this.mapCheckData(newLimits['5000'])
              if (newLimits['5000'].length === this.invoiceData.length) {
                this.invoiceIsTrue = true
              } else {
                this.invoiceIsTrue = false
              }
            }
            if (!this.allIsTrue && this.userIsTrue && this.dealIsTrue && this.contentIsTrue && this.calculateIsTrue && this.invoiceIsTrue) {
              this.allIsTrue = true
            } else {
              this.allIsTrue = false
            }
          }
        }
      })
    },
    // 重构数组
    mapData(data) {
      var newData = data.map(item => {
        return item.id
      })
      return newData
    },
    mapCheckData(data) {
      var checkData = data.map(item => {
        return Number(item)
      })
      return checkData
    }
  },
  mounted() {
    this.jurisdictionDetails()
  }
}
</script>
<style lang="scss">
  .content-title{
    font-size:14px;
    font-weight:600;
    color:rgba(93,111,128,1);
    line-height:14px;
  }
  .content-hint{
    padding-left: 58px;
    font-size:12px;
    font-weight:400;
    color:rgba(181,194,208,1);
    line-height:12px;
  }
  .content-top,.content-bottom {
    padding: 30px 20px;
    background: rgba(255,255,255,1);
    box-shadow: 0 4px 8px 1px rgba(135,150,176,0.09);
  }
  .content-top {
    padding-left: 30px;
    margin-bottom: 10px;
    .content-title {
      margin-left: -10px;
      margin-bottom: 24px;
    }
    .ivu-form-item {
      margin-bottom: 10px;
    }
    .ivu-form-item-content {
      height: 32px;
      line-height: 32px;
    }
    .ivu-input-wrapper {
      width: 210px;
      .ivu-input {
        width:210px;
        height:32px;
        line-height: 32px;
        border-radius:4px;
      }
    }
    .ivu-form-item-error-tip {
      top: 0;
      left: 0;
    }
    .ivu-form-item .ivu-form-item-label {
      padding: 0 0;
      margin-right: 10px;
    }
  }
  .content-bottom {
    .ivu-checkbox-group {
      display: inline-block;
    }
    .content-title {
      margin-bottom: 19px;
    }
    li {
      line-height: 40px;
      box-sizing: content-box;
      white-space: nowrap;
      overflow: hidden;
      height: 40px;
      border-bottom: 1px solid #D9E2EF;
      .ivu-checkbox-group .checkbox-val{
        display: inline-block;
        width: 194px;
        margin-right: 0;
      }
      .ivu-checkbox-wrapper {
        margin-right: 0;
      }
      .checkbox-all {
        .ivu-checkbox-wrapper span:last-child{
          display: inline-block;
          width: auto;
          margin: 0 60px;
          color: #D9E2EF;
        }
      }
    }
  }
  .content-footer {
    text-align: right;
    margin-top: 30px;
    padding-right: 20px;
    .ivu-form-item-content {
      height: 28px;
      line-height: 28px;
      .ivu-btn>span{
        vertical-align: bottom;
      }
    }
  }
</style>

